/*
 * サブシステム名：マスタ管理
 * 機能名：発着地単価一覧
 */

import DdTextBox from '@/components/DdTextBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDropDown from '@/components/DdDropDown'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

export default {
  name: 'MstHacchakuchiTankaList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      tankahyoCd: '',
      hinmeiCd: '',
      hatsuchiCd: '',
      chakuchiCd: '',
      torihikisakiCd: ''
    },
    headersHinmeiList: header.mstHinmeiHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdCodeTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdDropDown
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''

        // 距離範囲
        if (elem.kyoriFrom !== null && elem.kyoriFrom !== undefined) {
          elem.kyoriFromDisp = filter.numericFormatter(elem.kyoriFrom)
        } else {
          elem.kyoriFromDisp = ''
        }
        if (elem.kyoriTo !== null && elem.kyoriTo !== undefined) {
          elem.kyoriToDisp = filter.numericFormatter(elem.kyoriTo)
        } else {
          elem.kyoriToDisp = ''
        }
        // 数量範囲
        if (elem.suryoFrom !== null && elem.suryoFrom !== undefined) {
          elem.suryoFromDisp = filter.numericFormatter(elem.suryoFrom)
        } else {
          elem.suryoFromDisp = ''
        }
        if (elem.suryoTo !== null && elem.suryoTo !== undefined) {
          elem.suryoToDisp = filter.numericFormatter(elem.suryoTo)
        } else {
          elem.suryoToDisp = ''
        }
        // 重量範囲
        if (elem.juryoFrom !== null && elem.juryoFrom !== undefined) {
          elem.juryoFromDisp = filter.numericFormatter(elem.juryoFrom)
        } else {
          elem.juryoFromDisp = ''
        }
        if (elem.juryoTo !== null && elem.juryoTo !== undefined) {
          elem.juryoToDisp = filter.numericFormatter(elem.juryoTo)
        } else {
          elem.juryoToDisp = ''
        }
        // 運賃車両サイズ範囲
        if (elem.sharyoSizeFrom !== null && elem.sharyoSizeFrom !== undefined) {
          elem.sharyoSizeFromDisp = filter.numericFormatter(elem.sharyoSizeFrom)
        } else {
          elem.sharyoSizeFromDisp = ''
        }
        if (elem.sharyoSizeTo !== null && elem.sharyoSizeTo !== undefined) {
          elem.sharyoSizeToDisp = filter.numericFormatter(elem.sharyoSizeTo)
        } else {
          elem.sharyoSizeToDisp = ''
        }
        // 単価
        if (elem.tanka !== null && elem.tanka !== undefined) {
          elem.tankaDisp = filter.numericFormatter(elem.tanka)
        } else {
          elem.tankaDisp = ''
        }
        // 基本運賃
        if (elem.kihonUnchin !== null && elem.kihonUnchin !== undefined) {
          elem.kihonUnchinDisp = filter.numericFormatter(elem.kihonUnchin)
        } else {
          elem.kihonUnchinDisp = ''
        }
        // 時間割増金額（課税）
        if (elem.jikanWarimashiKingaku !== null && elem.jikanWarimashiKingaku !== undefined) {
          elem.jikanWarimashiKingakuDisp = filter.numericFormatter(elem.jikanWarimashiKingaku)
        } else {
          elem.jikanWarimashiKingakuDisp = ''
        }
        // 距離割増金額（課税）
        if (elem.kyoriWarimashiKingaku !== null && elem.kyoriWarimashiKingaku !== undefined) {
          elem.kyoriWarimashiKingakuDisp = filter.numericFormatter(elem.kyoriWarimashiKingaku)
        } else {
          elem.kyoriWarimashiKingakuDisp = ''
        }
        // 係数割増金額（課税）
        if (elem.keisuWarimashiKingaku !== null && elem.keisuWarimashiKingaku !== undefined) {
          elem.keisuWarimashiKingakuDisp = filter.numericFormatter(elem.keisuWarimashiKingaku)
        } else {
          elem.keisuWarimashiKingakuDisp = ''
        }
        // 燃料割増金額（課税）
        if (elem.nenryoWarimashiKingaku !== null && elem.nenryoWarimashiKingaku !== undefined) {
          elem.nenryoWarimashiKingakuDisp = filter.numericFormatter(elem.nenryoWarimashiKingaku)
        } else {
          elem.nenryoWarimashiKingakuDisp = ''
        }
        // 高速代（課税）
        if (elem.hiwayPrice !== null && elem.hiwayPrice !== undefined) {
          elem.hiwayPriceDisp = filter.numericFormatter(elem.hiwayPrice)
        } else {
          elem.hiwayPriceDisp = ''
        }
        // ユーザー金額1~10（課税）
        if (elem.userKingakuKazei1 !== null && elem.userKingakuKazei1 !== undefined) {
          elem.userKingakuKazei1Disp = filter.numericFormatter(elem.userKingakuKazei1)
        } else {
          elem.userKingakuKazei1Disp = ''
        }
        if (elem.userKingakuKazei2 !== null && elem.userKingakuKazei2 !== undefined) {
          elem.userKingakuKazei2Disp = filter.numericFormatter(elem.userKingakuKazei2)
        } else {
          elem.userKingakuKazei2Disp = ''
        }
        if (elem.userKingakuKazei3 !== null && elem.userKingakuKazei3 !== undefined) {
          elem.userKingakuKazei3Disp = filter.numericFormatter(elem.userKingakuKazei3)
        } else {
          elem.userKingakuKazei3Disp = ''
        }
        if (elem.userKingakuKazei4 !== null && elem.userKingakuKazei4 !== undefined) {
          elem.userKingakuKazei4Disp = filter.numericFormatter(elem.userKingakuKazei4)
        } else {
          elem.userKingakuKazei4Disp = ''
        }
        if (elem.userKingakuKazei5 !== null && elem.userKingakuKazei5 !== undefined) {
          elem.userKingakuKazei5Disp = filter.numericFormatter(elem.userKingakuKazei5)
        } else {
          elem.userKingakuKazei5Disp = ''
        }
        if (elem.userKingakuKazei6 !== null && elem.userKingakuKazei6 !== undefined) {
          elem.userKingakuKazei6Disp = filter.numericFormatter(elem.userKingakuKazei6)
        } else {
          elem.userKingakuKazei6Disp = ''
        }
        if (elem.userKingakuKazei7 !== null && elem.userKingakuKazei7 !== undefined) {
          elem.userKingakuKazei7Disp = filter.numericFormatter(elem.userKingakuKazei7)
        } else {
          elem.userKingakuKazei7Disp = ''
        }
        if (elem.userKingakuKazei8 !== null && elem.userKingakuKazei8 !== undefined) {
          elem.userKingakuKazei8Disp = filter.numericFormatter(elem.userKingakuKazei8)
        } else {
          elem.userKingakuKazei8Disp = ''
        }
        if (elem.userKingakuKazei9 !== null && elem.userKingakuKazei9 !== undefined) {
          elem.userKingakuKazei9Disp = filter.numericFormatter(elem.userKingakuKazei9)
        } else {
          elem.userKingakuKazei9Disp = ''
        }
        if (elem.userKingakuKazei10 !== null && elem.userKingakuKazei10 !== undefined) {
          elem.userKingakuKazei10Disp = filter.numericFormatter(elem.userKingakuKazei10)
        } else {
          elem.userKingakuKazei10Disp = ''
        }
        // ユーザー金額1~10（非課税）
        if (elem.userKingakuHikazei1 !== null && elem.userKingakuHikazei1 !== undefined) {
          elem.userKingakuHikazei1Disp = filter.numericFormatter(elem.userKingakuHikazei1)
        } else {
          elem.userKingakuHikazei1Disp = ''
        }
        if (elem.userKingakuHikazei2 !== null && elem.userKingakuHikazei2 !== undefined) {
          elem.userKingakuHikazei2Disp = filter.numericFormatter(elem.userKingakuHikazei2)
        } else {
          elem.userKingakuHikazei2Disp = ''
        }
        if (elem.userKingakuHikazei3 !== null && elem.userKingakuHikazei3 !== undefined) {
          elem.userKingakuHikazei3Disp = filter.numericFormatter(elem.userKingakuHikazei3)
        } else {
          elem.userKingakuHikazei3Disp = ''
        }
        if (elem.userKingakuHikazei4 !== null && elem.userKingakuHikazei4 !== undefined) {
          elem.userKingakuHikazei4Disp = filter.numericFormatter(elem.userKingakuHikazei4)
        } else {
          elem.userKingakuHikazei4Disp = ''
        }
        if (elem.userKingakuHikazei5 !== null && elem.userKingakuHikazei5 !== undefined) {
          elem.userKingakuHikazei5Disp = filter.numericFormatter(elem.userKingakuHikazei5)
        } else {
          elem.userKingakuHikazei5Disp = ''
        }
        if (elem.userKingakuHikazei6 !== null && elem.userKingakuHikazei6 !== undefined) {
          elem.userKingakuHikazei6Disp = filter.numericFormatter(elem.userKingakuHikazei6)
        } else {
          elem.userKingakuHikazei6Disp = ''
        }
        if (elem.userKingakuHikazei7 !== null && elem.userKingakuHikazei7 !== undefined) {
          elem.userKingakuHikazei7Disp = filter.numericFormatter(elem.userKingakuHikazei7)
        } else {
          elem.userKingakuHikazei7Disp = ''
        }
        if (elem.userKingakuHikazei8 !== null && elem.userKingakuHikazei8 !== undefined) {
          elem.userKingakuHikazei8Disp = filter.numericFormatter(elem.userKingakuHikazei8)
        } else {
          elem.userKingakuHikazei8Disp = ''
        }
        if (elem.userKingakuHikazei9 !== null && elem.userKingakuHikazei9 !== undefined) {
          elem.userKingakuHikazei9Disp = filter.numericFormatter(elem.userKingakuHikazei9)
        } else {
          elem.userKingakuHikazei9Disp = ''
        }
        if (elem.userKingakuHikazei10 !== null && elem.userKingakuHikazei10 !== undefined) {
          elem.userKingakuHikazei10Disp = filter.numericFormatter(elem.userKingakuHikazei10)
        } else {
          elem.userKingakuHikazei10Disp = ''
        }
        // ユーザー金額1~10（内税）
        if (elem.userKingakuUchizei1 !== null && elem.userKingakuUchizei1 !== undefined) {
          elem.userKingakuUchizei1Disp = filter.numericFormatter(elem.userKingakuUchizei1)
        } else {
          elem.userKingakuUchizei1Disp = ''
        }
        if (elem.userKingakuUchizei2 !== null && elem.userKingakuUchizei2 !== undefined) {
          elem.userKingakuUchizei2Disp = filter.numericFormatter(elem.userKingakuUchizei2)
        } else {
          elem.userKingakuUchizei2Disp = ''
        }
        if (elem.userKingakuUchizei3 !== null && elem.userKingakuUchizei3 !== undefined) {
          elem.userKingakuUchizei3Disp = filter.numericFormatter(elem.userKingakuUchizei3)
        } else {
          elem.userKingakuUchizei3Disp = ''
        }
        if (elem.userKingakuUchizei4 !== null && elem.userKingakuUchizei4 !== undefined) {
          elem.userKingakuUchizei4Disp = filter.numericFormatter(elem.userKingakuUchizei4)
        } else {
          elem.userKingakuUchizei4Disp = ''
        }
        if (elem.userKingakuUchizei5 !== null && elem.userKingakuUchizei5 !== undefined) {
          elem.userKingakuUchizei5Disp = filter.numericFormatter(elem.userKingakuUchizei5)
        } else {
          elem.userKingakuUchizei5Disp = ''
        }
        if (elem.userKingakuUchizei6 !== null && elem.userKingakuUchizei6 !== undefined) {
          elem.userKingakuUchizei6Disp = filter.numericFormatter(elem.userKingakuUchizei6)
        } else {
          elem.userKingakuUchizei6Disp = ''
        }
        if (elem.userKingakuUchizei7 !== null && elem.userKingakuUchizei7 !== undefined) {
          elem.userKingakuUchizei7Disp = filter.numericFormatter(elem.userKingakuUchizei7)
        } else {
          elem.userKingakuUchizei7Disp = ''
        }
        if (elem.userKingakuUchizei8 !== null && elem.userKingakuUchizei8 !== undefined) {
          elem.userKingakuUchizei8Disp = filter.numericFormatter(elem.userKingakuUchizei8)
        } else {
          elem.userKingakuUchizei8Disp = ''
        }
        if (elem.userKingakuUchizei9 !== null && elem.userKingakuUchizei9 !== undefined) {
          elem.userKingakuUchizei9Disp = filter.numericFormatter(elem.userKingakuUchizei9)
        } else {
          elem.userKingakuUchizei9Disp = ''
        }
        if (elem.userKingakuUchizei10 !== null && elem.userKingakuUchizei10 !== undefined) {
          elem.userKingakuUchizei10Disp = filter.numericFormatter(elem.userKingakuUchizei10)
        } else {
          elem.userKingakuUchizei10Disp = ''
        }

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei'
    }),
    // 品名リスト
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 取引先リスト
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地リスト
    filteredHacchakuchiList () {
      console.log('filteredhacchakuchiList')
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        console.log('filteredhacchakuchiList Mapping')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        console.log('filteredhacchakuchiList filter')
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msthacchakuchi', 'msthinmei'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('MstHacchakuchiTankaList.defineHeaderPromise')
            self.headers = [
              { text: '単価表コード', value: 'tankahyoCd' },
              { text: '単価表種類区分', value: 'tankahyokbnNm' },
              { text: '単価表種類詳細区分', value: 'tankahyodetailkbnNm' },
              { text: '金額合計(目安)', value: 'tankaAmountDisp', align: 'end' },
              { text: '取引先名称', value: 'torihikisakiNm' },
              { text: '営業所名称', value: 'eigyoshoNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '発地地区', value: 'hatsuchikuNm', align: 'center' },
              { text: '着地地区', value: 'chakuchikuNm', align: 'center' },
              { text: '品名', value: 'hinmeiNm' },
              { text: '単価', value: 'tankaDisp', align: 'end' },
              { text: '運賃計算方法区分', value: 'unchinKeisanKbnNm', align: 'center' },
              // 追加条件
              { text: '距離(Km)_From', value: 'kyoriFromDisp', align: 'end' },
              { text: '距離(Km)_To', value: 'kyoriToDisp', align: 'end' },
              { text: '数量_From', value: 'suryoFromDisp', align: 'end' },
              { text: '数量_To', value: 'suryoToDisp', align: 'end' },
              { text: '重量_From', value: 'juryoFromDisp', align: 'end' },
              { text: '重量_To', value: 'juryoToDisp', align: 'end' },
              { text: '運賃車両サイズ_From', value: 'sharyoSizeFromDisp', align: 'end' },
              { text: '運賃車両サイズ_To', value: 'sharyoSizeToDisp', align: 'end' },
              // 固定金額
              { text: '基本運賃(課税)', value: 'kihonUnchinDisp', align: 'end' },
              { text: '時間割増金額(課税)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
              { text: '距離割増金額(課税)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
              { text: '係数割増金額(課税)', value: 'keisuWarimashiKingakuDisp', align: 'end' },
              { text: '燃料割増金額(課税)', value: 'nenryoWarimashiKingakuDisp', align: 'end' },
              { text: '高速代(課税)', value: 'hiwayPriceDisp', align: 'end' },
              // ユーザー金額(課税)1~10
              { text: '金額1(課税)', value: 'userKingakuKazei1Disp', align: 'end' },
              { text: '金額2(課税)', value: 'userKingakuKazei2Disp', align: 'end' },
              { text: '金額3(課税)', value: 'userKingakuKazei3Disp', align: 'end' },
              { text: '金額4(課税)', value: 'userKingakuKazei4Disp', align: 'end' },
              { text: '金額5(課税)', value: 'userKingakuKazei5Disp', align: 'end' },
              { text: '金額6(課税)', value: 'userKingakuKazei6Disp', align: 'end' },
              { text: '金額7(課税)', value: 'userKingakuKazei7Disp', align: 'end' },
              { text: '金額8(課税)', value: 'userKingakuKazei8Disp', align: 'end' },
              { text: '金額9(課税)', value: 'userKingakuKazei9Disp', align: 'end' },
              { text: '金額10(課税)', value: 'userKingakuKazei10Disp', align: 'end' },
              // ユーザー金額(非課税)1~10
              { text: '金額1(非課税)', value: 'userKingakuHikazei1Disp', align: 'end' },
              { text: '金額2(非課税)', value: 'userKingakuHikazei2Disp', align: 'end' },
              { text: '金額3(非課税)', value: 'userKingakuHikazei3Disp', align: 'end' },
              { text: '金額4(非課税)', value: 'userKingakuHikazei4Disp', align: 'end' },
              { text: '金額5(非課税)', value: 'userKingakuHikazei5Disp', align: 'end' },
              { text: '金額6(非課税)', value: 'userKingakuHikazei6Disp', align: 'end' },
              { text: '金額7(非課税)', value: 'userKingakuHikazei7Disp', align: 'end' },
              { text: '金額8(非課税)', value: 'userKingakuHikazei8Disp', align: 'end' },
              { text: '金額9(非課税)', value: 'userKingakuHikazei9Disp', align: 'end' },
              { text: '金額10(非課税)', value: 'userKingakuHikazei10Disp', align: 'end' },
              // ユーザー金額(内税)1~10
              { text: '金額1(内税)', value: 'userKingakuUchizei1Disp', align: 'end' },
              { text: '金額2(内税)', value: 'userKingakuUchizei2Disp', align: 'end' },
              { text: '金額3(内税)', value: 'userKingakuUchizei3Disp', align: 'end' },
              { text: '金額4(内税)', value: 'userKingakuUchizei4Disp', align: 'end' },
              { text: '金額5(内税)', value: 'userKingakuUchizei5Disp', align: 'end' },
              { text: '金額6(内税)', value: 'userKingakuUchizei6Disp', align: 'end' },
              { text: '金額7(内税)', value: 'userKingakuUchizei7Disp', align: 'end' },
              { text: '金額8(内税)', value: 'userKingakuUchizei8Disp', align: 'end' },
              { text: '金額9(内税)', value: 'userKingakuUchizei9Disp', align: 'end' },
              { text: '金額10(内税)', value: 'userKingakuUchizei10Disp', align: 'end' },

              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.conditions = {
              tankahyoCd: '',
              hinmeiCd: '',
              hatsuchiCd: '',
              chakuchiCd: '',
              torihikisakiCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstThacchakuchiTankaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstThacchakuchiTankaList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstThacchakuchiTankaList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstThacchakuchiTankaList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstHacchakuchiTanka/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              tankahyoCd: '',
              hinmeiCd: '',
              hatsuchiCd: '',
              chakuchiCd: '',
              torihikisakiCd: ''
            }
            self.searchText = ''
            self.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      console.log('編集画面呼び出し開始')
      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient.post('/api/v1/VwCMstHacchakuchiTanka/download', this.conditions).then((data) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        elem.href = window.URL.createObjectURL(blob)
        // elem.download = '発着地単価マスタ一覧_' + this.getFormatDate(new Date()) + '.csv'
        elem.click()
        this.Effects.loadComplete()
      })
    },
    onCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 0', e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
